// extracted by mini-css-extract-plugin
export default {"auNav":"index_auNav_fQpEy","auNavCur":"index_auNavCur_TtP36"};